module.exports = __webpack_public_path__ + "assets/fb7bc158872676d7320f54ab6c0bbc28.png";